module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"code":"コード","name":"名前","type_code":"タイプコード","type_name":"タイプ名","field_is_required":"必須項目です","brand_code_length":"ブランドコードの長さは4文字です"}}')
  delete Component.options._Ctor
}
